<div tabindex="0" class="row comunicado-container"
  style="background-color: var(--secondary-red); color: white;">
  <div class="col-12 col-md-6 comunicado-texto-padrao">
    <h2>
      <img width="48px" style="margin-right: 1rem;" src="icons/megaphone-line-white.svg" alt="Ícone de megafone" />
      Comunicados
    </h2>
    <p style="color: white;">Acompanhe os comunicados sobre a publicação do jornal</p>
    <div class="comunicados-container-link" style="display: grid;">
      <span tabindex="0" (click)="goToComunicados()" (keyup.enter)="goToComunicados()"
      style="text-decoration: underline; color: white; cursor: pointer; width: fit-content;">Ver todos os comunicados &rarr;</span>
    </div>
  </div>
  <div class="col-md-6 col-12">
    <lib-segov-sigepo-simple-card [titulo]="ComunicadoOutputDto?.titulo" [subtitulo]="DataFormatada"
      [conteudoTexto]="ComunicadoOutputDto?.resumo"
      [customTitleStyle]="'font-weight: 600; color: var(--text-geral-fundo-claro);'"
      [customSubTitleStyle]="'color: var(--text-secondary-red); font-weight: 600'"
      [customBodyStyle]="'color: var(--text-geral-fundo-claro)'" />
  </div>
</div>
